import { createAction } from '../../../../../store.model';
import { BehaviourTag } from '../../../model/behaviour-tag.model';
import { ActionType } from '../behaviour-selection-dialog.action';

export interface CheckboxSelected {
    behaviourTag: BehaviourTag;
}
export const checkboxSelected = createAction<ActionType, CheckboxSelected>(
    ActionType.COACHING_DETAIL__BSD__CHECKBOX_SELECTED,
);
